import { useCallback } from 'react';
import { deleteTask } from '../api';
import { tasksInformationActions } from '../model/slice/tasksInformation';
import { useAppDispatch } from '../../../store';
import { Task } from '../model/types/tasks';

interface UseDeleteTaskProps {
    taskData: Task;
    pickedTaskUid: string;
    isModalLoading?: boolean;
    onHideModal?: () => void;
}

export const useDeleteTask = ({
    isModalLoading,
    taskData,
    pickedTaskUid,
    onHideModal,
}: UseDeleteTaskProps) => {
    const dispatch = useAppDispatch();

    const deleteTaskHandler = useCallback(async () => {
        if (isModalLoading) return;

        try {
            await dispatch(
                deleteTask({ entity_uid: taskData?.context?.entity_uid, uid: pickedTaskUid })
            ).unwrap();
            dispatch(tasksInformationActions.onDeleteTab(pickedTaskUid));
            if (onHideModal) {
                onHideModal();
            }
        } catch (error) {
            console.error('Error in delete task:', error);
        }
    }, [isModalLoading, dispatch, taskData, pickedTaskUid, onHideModal]);

    return { deleteTaskHandler };
};
